import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store.js'
import Login from '@/views/Login.vue'
import AllOrders from '@/views/AllOrders.vue'
import Order from '@/views/Order.vue'
import Cashbox from '@/views/Cashbox.vue'
import Directories from '@/views/Directories.vue'
import AdditionalCategories from '@/views/AdditionalCategories.vue'
import DowntimeCategories from '@/views/DowntimeCategories.vue'
import FurnitureCategories from '@/views/FurnitureCategories.vue'
import GarbageRemoval from '@/views/GarbageRemoval.vue'
import MoverCategories from '@/views/MoverCategories.vue'
import PetrolCategories from '@/views/PetrolCategories.vue'
import TruckingCategories from '@/views/TruckingCategories.vue'
import TruckingCategory from '@/views/TruckingCategory.vue'
import AdditionalCategory from '@/views/AdditionalCategory.vue'
import DowntimeCategory from '@/views/DowntimeCategory.vue'
import FurnitureCategory from '@/views/FurnitureCategory.vue'
import GarbageRemovalCategory from '@/views/GarbageRemovalCategory.vue'
import MoverCategory from '@/views/MoverCategory.vue'
import PetrolCategory from '@/views/PetrolCategory.vue'
import Districts from '@/views/Districts.vue'
import Regions from '@/views/Regions.vue'
import LeewayTable from '@/views/LeewayTable.vue'
import District from '@/views/District.vue'
import Leeway from '@/views/Leeway.vue'
import Region from '@/views/Region.vue'
import GarbageDisposalDistrict from '@/views/GarbageDisposalDistrict.vue'
import ErrorPage from '@/components/ErrorPage.vue'
import Worker from '@/views/Worker.vue'
import WorkersBase from '@/views/WorkersBase.vue'
import Settings from '@/views/Settings.vue'
import WorkersInShift from '@/views/WorkersInShift.vue'

Vue.use(Router)

const checkAuth = (to, from, next) => {
  store.dispatch('isAuthenticated')
    .then(() => next())
    .catch(() => {
      sessionStorage.setItem('shustrikoff_redirect', to.path)
      next('/')
    })
}

const checkRole = (from, next, roles) => {
  store.dispatch('isAuthenticated').then(() => {
    let access = false
    roles.forEach(role => {
      if (store.getters.roleCode === role) { access = true }
    })
    if (!access) {
      if (from.params.code === '403') { window.history.go(-1) } else { next('/error/403') }
    }
  }).catch(() => next())
}

const checkAuthAndSpotDirectoryTab = (to, from, next) => {
  checkAuth(to, from, next)
  checkRole(from, next, ['ROLE_SUPER_ADMIN'])

  // определение из какого компонента был совершен переход на страницу справочников
  // если переход был совершен из компонента со второй вкладки на странице справочников (стрелка "справочники")
  if (from.name === 'Districts' || from.name === 'Regions' || from.name === 'LeewayTable') { store.commit('updateDirectoryTabNumber', 1) }

  // если переход был совершен из компонента со второй вкладки на странице справочников
  // FIXME: добавить сюда определение компонента, когда компоненты с 3-ей вкладки будут реализованы
  else if (false) { store.commit('updateDirectoryTabNumber', 2) }

  // если переход был совершен из компонента со первой вкладки на странице справочников, либо из любого другого
  else { store.commit('updateDirectoryTabNumber', 0) }

  /* FIXME: опираться на наименование компонента в данном случае неверно, так как оно может поменяться, и тогда
   * переименовать нужно будет и здесь. аналогичный подход используется, например в MenuDispatcher.
   * кейс переименоваия компонента максимально редкий, тем не менее это возможно, за этим нужно следитью
   * чтобы не следить, нужно найти более правильное решение */

  next()
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    component: Login
  },
  {
    path: '/orders',
    component: AllOrders,
    name: 'AllOrders',
    beforeEnter: checkAuth
  },
  {
    path: '/orders/:id',
    component: Order,
    name: 'Order',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next);

      let roles = ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_DISPATCHER'];
      if (to.params.id != 'new') {
        // Бухгалтер может просматривать заявки, но не создавать
        roles = roles.concat(['ROLE_BOOKER']);
      }

      checkRole(from, next, roles);
    }
  },
  {
    path: '/cashbox',
    component: Cashbox,
    name: 'Cashbox',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'])
    }
  },
  {
    path: '/directories',
    component: Directories,
    name: 'Directories',
    beforeEnter: checkAuthAndSpotDirectoryTab
  },
  {
    path: '/directories/trucking-categories',
    component: TruckingCategories,
    name: 'TruckingCategories',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/workers-base/worker-card/:id',
    component: Worker,
    name: 'Worker',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_HR', 'ROLE_DISPATCHER'])
    }
  },
  {
    path: '/settings',
    component: Settings,
    name: 'Settings',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/downtime-categories',
    component: DowntimeCategories,
    name: 'DowntimeCategories',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/furniture-categories',
    component: FurnitureCategories,
    name: 'FurnitureCategories',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/garbage-removal',
    component: GarbageRemoval,
    name: 'GarbageRemoval',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/mover-categories',
    component: MoverCategories,
    name: 'MoverCategories',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/petrol-categories',
    component: PetrolCategories,
    name: 'PetrolCategories',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/additional-categories',
    component: AdditionalCategories,
    name: 'AdditionalCategories',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/trucking-categories/:id',
    component: TruckingCategory,
    name: 'TruckingCategory',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/downtime-categories/:id',
    component: DowntimeCategory,
    name: 'DowntimeCategory',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/furniture-categories/:id',
    component: FurnitureCategory,
    name: 'FurnitureCategory',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/garbage-removal-categories/:id',
    component: GarbageRemovalCategory,
    name: 'GarbageRemovalCategory',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/mover-categories/:id',
    component: MoverCategory,
    name: 'MoverCategory',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/petrol-categories/:id',
    component: PetrolCategory,
    name: 'PetrolCategory',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/additional-categories/:id',
    component: AdditionalCategory,
    name: 'AdditionalCategory',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/districts',
    component: Districts,
    name: 'Districts',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/regions',
    component: Regions,
    name: 'Regions',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/leeway',
    component: LeewayTable,
    name: 'LeewayTable',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/districts/:id',
    component: District,
    name: 'District',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/regions/:id',
    component: Region,
    name: 'Region',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/leeway/:id',
    component: Leeway,
    name: 'Leeway',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/directories/garbage-disposal-districts/:id',
    component: GarbageDisposalDistrict,
    name: 'GarbageDisposalDistrict',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN'])
    }
  },
  {
    path: '/workers-base',
    component: WorkersBase,
    name: 'WorkersBase',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_HR', 'ROLE_DISPATCHER'])
      let a = "/workers-base/worker-card/[0-9]+";
      if (from.path.search(a) !== -1) {
        store.commit('updateIsWorkerBaseRequestedFromWorkerCard', true)
      }
    },
  },
  {
    path: '/workers-in-shift',
    component: WorkersInShift,
    name: 'WorkersInShift',
    beforeEnter: (to, from, next) => {
      checkAuth(to, from, next)
      checkRole(from, next, ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_HR', 'ROLE_DISPATCHER'])
    }
  },
  {
    path: '/error/:code',
    component: ErrorPage,
    name: 'ErrorPage',
    beforeEnter: checkAuth
  },
  // дожно стоять последним
  {
    path: '/*',
    redirect: '/error/404',
    beforeEnter: checkAuth
  }
  ]
})
